function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "7jul3i5coa",
  d: "M0 0h71v100H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "inherit"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "bkx8qb4ugb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#7jul3i5coa"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.757 18.793h33.5C52.22 11.07 45.96 4.75 38.247 4.75c-5.955 0-10.678-.586-15.377 4.136a14.073 14.073 0 0 0-4.113 9.906zM0 92.14v-70.98a2.372 2.372 0 0 1 2.38-2.367h11.63C14.034 8.485 22.454.006 32.755.006c7.2 0 12.825-.403 18.732 5.54a18.779 18.779 0 0 1 5.503 13.248h11.643A2.369 2.369 0 0 1 71 21.161v70.982C71 96.45 67.473 100 63.165 100H7.835C3.526 100 0 96.45 0 92.142v-.001z",
  mask: "url(#bkx8qb4ugb)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M43.676 62v-5.163H33v-9.674h10.676V42L55 52.002zM28.497 76v-5.163H39v-9.679H28.497V56L16 65.998z"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 71,
  height: 100,
  viewBox: "0 0 71 100",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/exchanges.0a3a671a.svg";
export { SvgComponent as ReactComponent };